module.exports = __webpack_public_path__ + "static/img/message.17800c1a.svg";